<template>
  <div class="row mt-4">
    <div class="col-xs-12 col-md-6 p-4">
      <h3 class="mb-3">
        {{ $t('user.login-information.heading') }}
      </h3>
      <div class="form-group">
        <label for="">{{ $t('user.login-information.email') }} *</label>
        <input v-model="information.email" type="email"
               class="form-control"
               required
        >
      </div>
      <div class="form-group">
        <label for="">{{ $t('user.login-information.password') }} *</label>
        <input v-model="information.password" type="password"
               class="form-control"
               required
        >
      </div>
      <div class="form-group">
        <label for="">{{ $t('user.login-information.re-password') }} *</label>
        <input v-model="information.password2" type="password"
               class="form-control"
               required
        >
      </div>
    </div>
    <div class="col-xs-12 col-md-6 p-4">
      <h3 class="mb-3">
        {{ $t('user.add-information.heading') }}
      </h3>
      <div class="form-group">
        <label for="">{{ $t('user.add-information.firstname') }}</label>
        <input v-model="information.name" type="text" class="form-control">
      </div>
      <div class="form-group">
        <label for="">{{ $t('user.add-information.lastname') }}</label>
        <input v-model="information.surname" type="text" class="form-control">
      </div>
    </div>
    <div class="col-12 mt-3 text-center">
      <button type="button" class="btn btn-primary"
              :disabled="registrationPending"
              @click="register()"
      >
        <span v-if="registrationPending" class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
        ></span>
        {{ $t('registration.registration-form.btn') }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
    name: 'RegistrationForm',
    data: function() {
        return {
            information: {
                email: '',
                password: '',
                password2: '',
                name: '',
                surname: '',
            },
            registrationPending: false,
        }
    },
    methods: {
        async register() {
            this.registrationPending = true
            const validation = await this.validate()
            if (validation) {
                this.$store.dispatch('registration', this.information)
                    .then(response => {
                        this.flash('Registrace proběhla úspěšně', 'success', {
                            timeout: 2000,
                        })
                        this.registrationPending = false
                        this.$router.push('/')
                    })
            } else {
                this.registrationPending = false
            }
        },
        /**
       * provizorní validace
       */
        validate() {
            let good = true
            if (this.information.email.length < 8) {
                this.flash('Email musí být delší než 8 znaků', 'error', {
                    timeout: 2000,
                })
                good = false
            }
            if (this.information.password.length < 7) {
                this.flash('Heslo musí mít víc alespoň 6 znaků', 'error', {
                    timeout: 2000,
                })
                good = false
            }
            if (this.information.password !== this.information.password2) {
                this.flash('Hesla nejsou stejná', 'error', {
                    timeout: 2000,
                })
                good = false
            }
            return good
        },
    },
}
</script>
